import React, { useEffect, useRef, useState } from 'react'
import classNames from 'classnames'
import { LottieProps } from './LottiePlayer.d'
import Lottie from 'lottie-react'

const LottiePlayer = ({
  lottieFile,
  previewImage = null,
  hover = false,
  autoPlay = false,
  loop = false,
  mode = 'normal',
  direction = 1,
  speed = 1,
  corners = false,
  classes = ''
}: LottieProps) => {
  const lottieRef = useRef(null)
  const containerRef = useRef(null)
  const [isPlaying, setIsPlaying] = useState<boolean>(false)
  const [hideImage, setHideImage] = useState<boolean>(false)
  const [lottieJSON, setLottieJSON] = useState<any>(null)
  const [lottieDirection, setLottieDirection] = useState<number>(direction)

  const fetchJSON = React.useCallback(async () => {
    const data = await fetch(lottieFile).then((res) => res.json())
    setLottieJSON(data)
  }, [])

  useEffect(() => {
    fetchJSON().catch(console.error)
  }, [fetchJSON])

  useEffect(() => {
    lottieRef.current.setSpeed(speed)
    lottieRef.current.setDirection(direction)

    if (window.innerWidth < 992) {
      window.addEventListener('scroll', () => {
        playInview()
      })
    }
  }, [lottieRef])

  useEffect(() => {
    if (isPlaying) {
      if (previewImage) {
        setHideImage(true)
      }
      lottieRef.current.play()
    }
  }, [isPlaying])

  const playInview = () => {
    let rect = containerRef.current.getBoundingClientRect()
    if (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <=
        (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <=
        (window.innerWidth || document.documentElement.clientWidth) &&
      isPlaying === false
    ) {
      setIsPlaying(true)
    }
  }
  const hoverEffect = () => {
    if (hover && !isPlaying) {
      setIsPlaying(true)
    }
  }

  const lottieClasses = classNames(classes, 'lottie overflow-hidden relative', {
    'w-full h-full ': classes !== '',
    'rounded-lg lg:rounded-md': corners
  })

  const previewImageClasses = classNames(
    'object-cover h-full w-full absolute top-0 bottom-0 right-0 left-0 preview-img',
    {
      'rounded-lg lg:rounded-md': corners,
      block: !hideImage,
      hidden: hideImage
    }
  )

  return (
    <div
      ref={containerRef}
      className={lottieClasses}
      onMouseEnter={hoverEffect}
      onClick={() => lottieRef.current.goToAndPlay(0)}
      data-testid='lottie-player'
    >
      <Lottie
        lottieRef={lottieRef}
        onComplete={() => {
          if (mode === 'normal') {
            setIsPlaying(false)
          }
          if (mode === 'bounce') {
            setLottieDirection(lottieDirection * -1)
            lottieRef.current.setDirection(lottieDirection)
            lottieRef.current.play()
          }
        }}
        animationData={lottieJSON}
        loop={loop && mode !== 'bounce' ? true : false}
        autoplay={autoPlay}
        rendererSettings={{
          preserveAspectRatio: 'xMidYMid slice'
        }}
        className='w-full h-full'
      />
      {previewImage && (
        <img
          alt={previewImage.title}
          className={previewImageClasses}
          data-testid='lottie-player-previewImg'
          src={previewImage.url}
        />
      )}
    </div>
  )
}

export default LottiePlayer
